import React from 'react';

const TeamTitle = ({ text }) => (
  <div className="h-32 md:h-48 xl:h-64 text-center">
    <span className="text-white text-xl md:text-4xl xl:text-6xl font-MarkProHeavy leading-loose md:leading-none">{text}</span>
  </div>
);


export default TeamTitle;